import React from 'react';
import Header from '../component/Header'
import Footer from '../component/Footer'
import '../scss/legal-contnet.scss'
import '../scss/sub-banner.scss'
import ThankyouImg from '../assets/images/thankyou-header-img.svg' 
import ArrowIcon from '../assets/images/white-back-arrow.svg'
import { Link } from 'react-router-dom';
function Thankyou() {

  return (
    <>
      <Header />   
      <main className='main thankyou-page'>
        <div className='thankyou-box'>
          <img src={ThankyouImg} alt='' /> 
          <h2>Thank You!</h2>
          <p>Your payment has been successfully done.</p>
          <Link to="/" className="custom-bttn"><img src={ArrowIcon} alt="" /> Back to Homepage</Link>
        </div>
      </main>
      <Footer />
    </>
  )
}
export default Thankyou 


